import { observable, computed, action } from "mobx";
import { ROUTE_FROM_PEGNI,ROUTE_ESITI_CONTESTUALI  ,ROUTE_RICEVUTE,ROUTE_FROM_UNIMODWEB_BB, ROUTE_RICEVUTE_DETTAGLIO } from "../assets/frontendRouting";
import { PATH_GET_ID_ATMOS_UPLOAD_FLOW, PATH_CHIAMATA_A2D, PATH_TRAMISSIONE_PEGNO_INVIO, PATH_TRAMISSIONE_UNIMOD_INVIO, PATH_CONTROLLO_A2D,PATH_TRAMISSIONE_PEGNO_CERT_INVIO, PATH_TRASMISSIONE_COM_CANC } from "../config/presdoc-fe-config";


class TrasmissioneStore {

  constructor(root) {   
    this.service = root.service
    this.userInfoStore = root.userInfoStore;
    this.routingStore = root.routingStore;
    this.qualificheStore = root.qualificheStore;
    this.getUrlTrasmissione = this.getUrlTrasmissione.bind(this);

    
  }

  @observable loading = false;
  @observable invioEffettuato = false;
  @observable erroreInvio = '';
  @observable codiceInvio = undefined;
  @observable idAtmosDomanda = undefined;
  @observable idAtmosTitolo = undefined;
  @observable idAtmosProcura = undefined;
  @observable idAtmos = undefined;
  @observable esitoA2D = undefined;
  


  getUrlTrasmissione(tipoPratica) {
    return  tipoPratica == 'UN' ? PATH_TRAMISSIONE_UNIMOD_INVIO :
            tipoPratica == 'MP' ? PATH_TRAMISSIONE_PEGNO_INVIO : 
            tipoPratica == 'CP' ? PATH_TRAMISSIONE_PEGNO_CERT_INVIO : 
            tipoPratica == 'CI' ? PATH_TRASMISSIONE_COM_CANC : 
            ''
  }
 
  @action
  invio(params){
    this.loading = true;
    this.invioEffettuato = false;
    this.erroreInvio = ''
    this.codiceInvio = undefined
    params.identificativoReferente = this.qualificheStore.codiceFiscaleRiferimento();
    params.identificativoUtenza = this.qualificheStore.qualifica.identificativoUtenza;
    params.identificativoUtente = this.userInfoStore.userInfo.codiceFiscale;


    const MAX_LENGTH_FILE_NAME = process.env.MAX_LENGTH_FILE_NAME;

    // controllo nomi e presenza file
    if (! params.nomeFile.toLowerCase().includes('xml.p7m') && params.tipoInvio !== 'B'){
      console.log(params.nomeFile+ 'non contiene xml.p7m')
      this.invioEffettuato = true;
      this.loading = false;
      this.codiceInvio = 0;
      this.erroreInvio = 'La domanda deve essere in formato xml e firmata digitalmente';
      return;
    }
    // controllo nomi e presenza file
    if (! params.nomeFile.toLowerCase().includes('xml') && params.tipoInvio === 'B'){
      console.log(params.nomeFile+ 'non contiene xml')
      this.invioEffettuato = true;
      this.loading = false;
      this.codiceInvio = 0;
      this.erroreInvio = 'La domanda deve essere in formato xml ';
      return;
    }

    if (! params.nomeFile.length > MAX_LENGTH_FILE_NAME) {
      console.log(params.nomeFile+ 'è troppo lungo')
      this.invioEffettuato = true;
      this.loading = false;
      this.codiceInvio = 0;
      this.erroreInvio = 'Il file ha un nome troppo lungo';
      return;
    }

    /*if ( ! params.allegati[0] ){ // titolo mancante CONTROLLO COMMENTATO DA fpierantoni in data 19/09/2022 
      this.invioEffettuato = true;
      this.loading = false;
      this.codiceInvio = 0;
      this.erroreInvio = 'Inserire il titolo';
      return;
    }*/
    if (  params.allegati[0] ){ // e' presente il titolo
      if (
        ! params.allegati[0].nomeFile.toLowerCase().includes('pdf.p7m')
      /* &&
        ! params.allegati[0].nomeFile.toLowerCase().includes('tiff.p7m')  
        &&
        ! params.allegati[0].nomeFile.toLowerCase().includes('tif.p7m')*/
      ){
        this.invioEffettuato = true;
        this.loading = false;
        this.codiceInvio = 0;
      // this.erroreInvio = 'Il titolo deve essere in formato pdf o tiff e firmato digitalmente';
      this.erroreInvio = 'Il titolo deve essere in formato pdf e firmato digitalmente';
        return;
      }
      if (! params.allegati[0].nomeFile.length > MAX_LENGTH_FILE_NAME) {
        console.log(params.allegati[0].nomeFile+ 'è troppo lungo')
        this.invioEffettuato = true;
        this.loading = false;
        this.codiceInvio = 0;
        this.erroreInvio = 'Il file ha un nome troppo lungo';
        return;
      }
  }

  


    if (  params.allegati[1] ){ // e' presente la procura
      if (
        ! params.allegati[1].nomeFile.toLowerCase().includes('pdf.p7m')
     /*   &&
        ! params.allegati[1].nomeFile.toLowerCase().includes('tiff.p7m')  
        &&
        ! params.allegati[1].nomeFile.toLowerCase().includes('tif.p7m')*/
      ){
        this.invioEffettuato = true;
        this.loading = false;
        this.codiceInvio = 0;
        //this.erroreInvio = 'La procura deve essere in formato pdf o tiff e firmata digitalmente';
        this.erroreInvio = 'La procura deve essere in formato pdf e firmata digitalmente';
        return;
      }
      if (! params.allegati[1].nomeFile.length > MAX_LENGTH_FILE_NAME) {
        console.log(params.allegati[1].nomeFile+ 'è troppo lungo')
        this.invioEffettuato = true;
        this.loading = false;
        this.codiceInvio = 0;
        this.erroreInvio = 'Il file ha un nome troppo lungo';
        return;
      }

    }

    

  // fine controlli
    
const PATH_TRAMISSIONE = this.getUrlTrasmissione(params.tipoPratica);


    //params.codiceFiscaleRiferimento = 'STLMLS61D61A669K';
    this.service.doAjax('POST', `${PATH_TRAMISSIONE}`, params).then(response => {  
      this.loading = false;
      if(response.success) {
        this.invioEffettuato = true;
         this.codiceInvio = response.result.idPratica;
       }
    });
  }



  @action
  recuperaIdAtmos(flowIdentifier, tipo){
    this.loading = true;
    const cfAutenticato =this.userInfoStore.userInfo.codiceFiscaleUL?this.userInfoStore.userInfo.codiceFiscaleUL:this.userInfoStore.userInfo.codiceFiscale;
    const param ={
      idUpload : flowIdentifier,
      cf : cfAutenticato
    }
     const uri = `${PATH_GET_ID_ATMOS_UPLOAD_FLOW}`
   // const uri = `${PATH_GET_ID_ATMOS_UPLOAD_FLOW}`+'/'+flowIdentifier+'/'+cfAutenticato
    console.log("uri recuperIdAtmos", uri)
   this.service.doAjax('POST', uri, param) .then(response => {   
   // this.service.doAjax('GET', uri).then(response => {   
      this.loading = false;    
       if(response.success) {
         if (tipo){
           if (tipo == 'domanda'){
            this.idAtmosDomanda = response.result
           }else if (tipo == 'titolo'){
            this.idAtmosTitolo = response.result
          }else if (tipo == 'procura'){
            this.idAtmosProcura = response.result
           }
         }else { //tipo generico
          this.idAtmos = response.result
         } 
        
       }
    });
  }

  @action
  verificaFile(params,callback){
    return new Promise((resolve, reject) => {
    this.loading = true;
    this.verificaInviata= false;   
    if(!params.tipoInvio){
      params.tipoInvio = 'N';
    }
    this.service.doAjax('POST', `${PATH_CHIAMATA_A2D}`, params).then(response => {   
      if(response.success) {
        this.codiceInvio = response.result;
        resolve("Promise Resolved");
        
      }
      else{
        reject("Promise Rejected");
        this.loading = false;
      }
        
    });
  });
    
  }

  @action
  gotoEsitiContestuali(){
    this.routingStore.push(`${process.env.CONTEXT_PATH}${ROUTE_FROM_UNIMODWEB_BB}${ROUTE_ESITI_CONTESTUALI}`)
  }

  @action
  controlloServizioA2D(idPratica){
    return new Promise((resolve, reject) => {
    this.service.doAjax('GET', `${PATH_CONTROLLO_A2D}`+'/'+idPratica).then(response => {   
   //this.service.doAjax('GET', `${PATH_CONTROLLO_A2D}`+'/'+'58832917').then(response => {   
    
      if(response.success) {    
        this.esitoA2D = response.result;
        resolve("Promise Resolved");
      }
      else{
        reject("Promise Rejected");
      }
    
  })
})}

  @action
  reset(){
    this.loading = false;
    this.invioEffettuato = false;
    this.codiceInvio = undefined;
    this.idAtmosDomanda = undefined;
    this.idAtmosTitolo = undefined;
    this.idAtmosProcura = undefined;
    this.idAtmos = undefined;
  }


}

export default TrasmissioneStore;